// #727: Friend / Doctor / Social Media are retired from new bookings but stay
// in the store's sourceTypes (flagged `legacy`) so a record that carries one
// still displays its label. Booking forms offer only the current list, plus the
// value already on the record so an edit never blanks it.
export function offeredSourceTypes (sourceTypes, current) {
    return (sourceTypes || []).filter(s => !s.legacy || s.value === current)
}
